import React from 'react'

export default function FooterMenu() {
  return (
    <ul className="flex flex-row flex-wrap justify-start gap-2 p-0 my-4 lg:my-0">
      <li>
        <a
          href="https://jiulia.goodfellas.app"
          target="_blank"
          className="pb-2 me-2 border-b border-white/30 text-sm"
          rel="noreferrer"
        >
          Conheça a Jiulia (IA)
        </a>
      </li>
      <li>
        <a href="/sobre" className="pb-2 me-2 border-b border-white/30 text-sm">
          Sobre nós
        </a>
      </li>
      <li>
        <a
          href="/invista"
          className="pb-2 me-2 border-b border-white/30 text-sm"
        >
          Invista no Goodfellas
        </a>
      </li>
      <li>
        <a
          href="/contato"
          className="pb-2 me-2 border-b border-white/30 text-sm"
        >
          Contato
        </a>
      </li>
      <li>
        <a
          href="/exclusao-de-conta"
          className="pb-2 me-2 border-b border-white/30 text-sm"
        >
          Excluir conta
        </a>
      </li>
    </ul>
  )
}
